import { Routes, RouterModule } from '@angular/router';
import { ProjectSearchComponent } from 'app/modules/search-module/components/project-search/project-search.component';
import { SearchContainerComponent } from 'app/modules/search-module/components/search-container/search-container.component';
import { DetailSearchComponent } from 'app/modules/search-module/components/detail-search/detail-search.component';
import { AuthGuard } from '../auth/guards/auth.guard';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: '',
    component: SearchContainerComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'projects',
        pathMatch: 'full',
      },
      // {
      //   path: 'page/:page',
      //   redirectTo: 'projects/page/:page',
      //   pathMatch: 'full',
      // },
      {
        path: 'projects',
        component: ProjectSearchComponent,
      },
      {
        path: 'details/page/:page',
        component: DetailSearchComponent,
      },
    ],
  },
  {
    path: 'projects',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'projects',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'details',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'details/page/1',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class SearchRoutingModule {}
